import { render, staticRenderFns } from "./bigorder-list.vue?vue&type=template&id=2d78af12"
import script from "./bigorder-list.vue?vue&type=script&lang=js"
export * from "./bigorder-list.vue?vue&type=script&lang=js"
import style0 from "./bigorder-list.vue?vue&type=style&index=0&id=2d78af12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports